import * as React from "react";
import { Link } from "react-router-dom";
import * as routes from "../constants/routes";
import { AuthUserContext } from "../firebase/AuthUserContext";
import { auth } from "../firebase";
import { Menu , Icon } from 'semantic-ui-react'

export const Navigation = () => (

  <AuthUserContext.Consumer>
    {authUser => authUser && <NavigationAuth />}
  </AuthUserContext.Consumer>
);


const NavigationAuth = () => (

        <Menu size="massive" fixed="top" inverted borderless >
          <Menu.Item as={Link} to={routes.HOME} header>
            Gify Tounsi : Admin Panel
          </Menu.Item>
          <Menu.Menu position="right" style={{fontSize: '1rem'}}>
            <Menu.Item onClick={auth.doSignOut}><Icon name="sign out"/>Log out</Menu.Item>
          </Menu.Menu>
        </Menu>
);






// WEBPACK FOOTER //
// ./src/components/Navigation.tsx